export const tenantCookieName = "HHAXchange-tenant-id";
export const preferredLanguageCookieName = "client-preferred-language";
export const tutorialCookieName = "tutorialRunning";
